<template>
  <v-row
    class="mx-0"
    :class="{
      'pointer-events-none':
        preventiveId > 0 && preventiveEditData?.preventive?.visit_create_flag,
    }"
  >
    <v-col :md="vPShowCalendar ? 4 : 12" class="py-0">
      <v-row>
        <v-col :md="vPShowCalendar ? 12 : 12">
          <v-row class="">
            <v-col
              md="12"
              class="light-gray-background custom-border-bottom d-flex justify-space-between"
            >
              <v-spacer></v-spacer>
              <div>
                <v-btn
                  :disabled="prventiveLoading"
                  class="mx-2 custom-bold-button white--text"
                  color="cyan"
                  right
                  small
                  depressed
                  v-on:click="updateCalendar()"
                >
                  <v-icon small class="mr-2">mdi-calendar-blank</v-icon>
                  <span v-if="vPShowCalendar">Hide Calendar</span>
                  <span v-else>Show Calendar</span>
                </v-btn>
              </div>
            </v-col>
            <v-col :md="vPShowCalendar ? 12 : 12">
              <v-select
                dense
                filled
                :class="vPShowCalendar ? '' : 'custom-width-padding'"
                class="schedule-type-list"
                :disabled="prventiveLoading"
                item-color="cyan"
                :items="recurringPScheduleTypeList"
                placeholder="Schedule Type"
                solo
                flat
                :value="prventiveRecurringSchedule.type"
                return-object
                v-on:change="updateWeekDays($event)"
                hide-details
                color="cyan"
              />

              <div
                class="mt-2"
                v-if="prventiveRecurringSchedule?.type?.group == 'monthly'"
              >
                <v-radio-group
                  :disabled="prventiveLoading"
                  class="mt-0"
                  hide-details
                  mandatory
                  :value="prventiveRecurringSchedule.recurring_pattern"
                  v-on:change="
                    updateScheduleState(
                      'dbPRecurringSchedule.recurring_pattern',
                      $event
                    );
                    updateScheduleState(
                      'dbPRecurringSchedule.force_update',
                      false
                    );
                  "
                >
                  <v-radio
                    :disabled="prventiveLoading"
                    :value="1"
                    hide-details
                    color="cyan"
                  >
                    <template v-slot:label>
                      <div
                        :class="{
                          'disabled-rw pointer-events-none':
                            prventiveRecurringSchedule.recurring_pattern != 1,
                        }"
                        class="d-flex align-center font-weight-500"
                      >
                        <label class="text-center my-0 ml-2"
                          >Selection by Date</label
                        >
                      </div>
                    </template>
                  </v-radio>
                  <v-radio
                    :disabled="prventiveLoading"
                    :value="2"
                    hide-details
                    color="cyan"
                  >
                    <template v-slot:label>
                      <div
                        :class="{
                          'disabled-rw pointer-events-none':
                            prventiveRecurringSchedule.recurring_pattern != 2,
                        }"
                        class="d-flex align-center font-weight-500"
                      >
                        <div style="width: 150px">
                          <v-select
                            dense
                            filled
                            :disabled="prventiveLoading"
                            item-color="cyan"
                            :items="durationList"
                            item-text="long_name"
                            item-value="id"
                            placeholder="Select Day"
                            v-model="prventiveRecurringSchedule.week_day"
                            v-on:change="updateSchedule()"
                            solo
                            flat
                            hide-details
                            color="cyan"
                          />
                        </div>
                        <div style="width: 150px">
                          <v-select
                            dense
                            filled
                            :disabled="prventiveLoading"
                            item-color="cyan"
                            item-text="long_name"
                            item-value="id"
                            :items="PWeekDays"
                            placeholder="Select Week Day"
                            v-model="prventiveRecurringSchedule.week_count"
                            v-on:change="updateSchedule()"
                            solo
                            flat
                            hide-details
                            color="cyan"
                          />
                        </div>
                        <template
                          v-if="
                            prventiveRecurringSchedule?.type?.value ==
                            'twice_a_month'
                          "
                        >
                          <div class="ml-10" style="width: 150px">
                            <v-select
                              dense
                              filled
                              :disabled="prventiveLoading"
                              item-color="cyan"
                              :items="durationList"
                              item-text="long_name"
                              item-value="id"
                              placeholder="Select Day"
                              v-model="
                                prventiveRecurringSchedule.second_week_day
                              "
                              v-on:change="updateSchedule()"
                              solo
                              flat
                              hide-details
                              color="cyan"
                            />
                          </div>
                          <div style="width: 150px">
                            <v-select
                              dense
                              filled
                              :disabled="prventiveLoading"
                              item-color="cyan"
                              item-text="long_name"
                              item-value="id"
                              :items="PWeekDays"
                              placeholder="Select Week Day"
                              v-model="
                                prventiveRecurringSchedule.second_week_count
                              "
                              v-on:change="updateSchedule()"
                              solo
                              flat
                              hide-details
                              color="cyan"
                            />
                          </div>
                        </template>
                      </div>
                    </template>
                  </v-radio>
                </v-radio-group>
              </div>

              <v-row v-if="prventiveRecurringSchedule?.type?.group == 'weekly'">
                <v-col
                  class="py-0 my-0"
                  md="2"
                  v-for="(weekday, index) in PWeekDays"
                  :key="`job-weekday-${index}`"
                >
                  <v-checkbox
                    color="cyan"
                    :disabled="prventiveLoading || isDisabled(weekday.id)"
                    :label="
                      vPShowCalendar ? weekday.short_name : weekday.long_name
                    "
                    :input-value="
                      +prventiveRecurringSchedule.weeks.includes(weekday.id)
                    "
                    :true-value="1"
                    :false-value="0"
                    v-on:change="updateSelection(weekday.id)"
                    hide-details
                    class="mt-0"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col :md="vPShowCalendar ? 12 : 4">
              <label class="ml-2" for="visit-one-off-start-date"
                >Start Date</label
              >
              <DatePicker
                :disabled="prventiveLoading"
                v-on:change="
                  updateScheduleState(
                    'dbPRecurringSchedule.start_date',
                    $event
                  );
                  updateEndDate(true);
                  updateScheduleState(
                    'dbPRecurringSchedule.force_update',
                    false
                  );
                "
                :value="prventiveRecurringSchedule.start_date"
                key="visit-one-off-start-date"
                id="visit-one-off-start-date"
                placeholder="Start Date"
              />
            </v-col>
            <v-col :md="vPShowCalendar ? 12 : 4">
              <label class="ml-2" for="visit-one-off-start-time"
                >Start Time</label
              >
              <TimePicker
                key="visit-one-off-start-time"
                id="visit-one-off-start-time"
                placeholder="Start Time"
                type="start-time"
                :value="prventiveRecurringSchedule.start_time"
                :min-time="todayTime"
                v-on:change="
                  updateScheduleState('dbPRecurringSchedule.start_time', $event)
                "
              />
              <!--  <TimePicker
                :disabled="prventiveLoading"
                v-on:change="
                  updateScheduleState(
                    'dbPRecurringSchedule.start_time',
                    $event
                  );
                "
                :value="prventiveRecurringSchedule.start_time"
                key="visit-one-off-start-time"
                id="visit-one-off-start-time"
                placeholder="Start Time"
                type="start-time"
              /> -->
            </v-col>
            <v-col :md="vPShowCalendar ? 12 : 4">
              <label class="ml-2" for="visit-one-off-end-time">End Time</label>
              <TimePicker
                :disabled="prventiveLoading"
                key="visit-one-off-end-time"
                id="visit-one-off-end-time"
                placeholder="End Time"
                type="end-time"
                :intervel="60"
                :value="prventiveRecurringSchedule.end_time"
                :min-time="updatedDate"
                v-on:change="
                  updateScheduleState('dbPRecurringSchedule.end_time', $event);
                  updateScheduleState(
                    'dbPRecurringSchedule.force_update',
                    false
                  );
                "
              />
              <!--  <TimePicker
                :disabled="prventiveLoading"
                v-on:change="
                  updateScheduleState('dbPRecurringSchedule.end_time', $event);
                  updateScheduleState(
                    'dbPRecurringSchedule.force_update',
                    false
                  );
                "
                :value="prventiveRecurringSchedule.end_time"
                key="visit-one-off-end-time"
                id="visit-one-off-end-time"
                placeholder="End Time"
                type="end-time"
              /> -->
            </v-col>
            <v-col :md="vPShowCalendar ? 12 : 5">
              <v-radio-group
                :disabled="prventiveLoading"
                class="mt-0"
                hide-details
                :intervel="60"
                mandatory
                :value="prventiveRecurringSchedule.end_mode"
                v-on:change="
                  updateScheduleState('dbPRecurringSchedule.end_mode', $event);
                  updateScheduleState(
                    'dbPRecurringSchedule.force_update',
                    false
                  );
                "
              >
                <v-radio
                  :disabled="prventiveLoading"
                  :value="2"
                  hide-details
                  style="max-width: 365px !important"
                  color="cyan"
                >
                  <template v-slot:label>
                    <div
                      class="d-flex align-center"
                      :class="{
                        'disabled-rw pointer-events-none':
                          prventiveRecurringSchedule.end_mode != 2,
                      }"
                    >
                      <div>End after</div>
                      <div class="mx-2">
                        <v-text-field
                          dense
                          :disabled="
                            prventiveLoading ||
                            prventiveRecurringSchedule.end_mode != 2
                          "
                          filled
                          :value="prventiveRecurringSchedule.occurrence"
                          type="number"
                          placeholder="occurrences"
                          v-on:change="
                            updateScheduleState(
                              'dbPRecurringSchedule.occurrence',
                              $event
                            );
                            updateScheduleState(
                              'dbPRecurringSchedule.force_update',
                              false
                            );
                          "
                          solo
                          flat
                          color="cyan"
                        />
                      </div>
                      <div>occurrences</div>
                    </div>
                  </template>
                </v-radio>
                <v-radio
                  :disabled="prventiveLoading"
                  :value="3"
                  hide-details
                  color="cyan"
                  style="max-width: 319px !important"
                  v-on:click="updateEndDate(true)"
                >
                  <template v-slot:label>
                    <div
                      class="d-flex align-center"
                      :class="{
                        'disabled-rw pointer-events-none':
                          prventiveRecurringSchedule.end_mode != 3,
                      }"
                    >
                      <div class="mr-2">End after</div>
                      <DatePicker
                        :disabled="
                          prventiveLoading ||
                          prventiveRecurringSchedule.end_mode != 3
                        "
                        :value="
                          prventiveRecurringSchedule.end_mode == 3
                            ? prventiveRecurringSchedule.end_date
                            : ''
                        "
                        v-on:change="
                          updateScheduleState(
                            'dbPRecurringSchedule.end_date',
                            $event
                          );
                          updateScheduleState(
                            'dbPRecurringSchedule.force_update',
                            false
                          );
                        "
                        :min-date="prventiveRecurringSchedule.start_date"
                        key="visit-recurring-end-date"
                        placeholder="Select End Date"
                      />
                    </div>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-col>
            <v-col md="12">
              <table width="100%">
                <tr>
                  <td
                    class="m-0 px-4 font-size-16 font-weight-500 light-gray-background custom-grey-border"
                  >
                    {{ prventiveRecurringSchedule.message }}
                  </td>
                  <td width="150px" class="px-0 py-0">
                    <v-btn
                      v-if="preventiveScheduleOutput.length"
                      :disabled="prventiveLoading || loadingDialog"
                      :loading="loadingDialog"
                      v-on:click="openDialog()"
                      :style="`min-height: ${
                        vPShowCalendar ? '56px' : '36.5px'
                      }; width: 100%;`"
                      color="cyan white--text"
                      depressed
                      class="custom-bold-button"
                    >
                      Show Schedule
                    </v-btn>
                    <v-btn
                      v-else
                      :disabled="prventiveLoading || loadingDialog"
                      :loading="loadingDialog"
                      v-on:click="showSchedule()"
                      :style="`min-height: ${
                        vPShowCalendar ? '56px' : '36.5px'
                      }; width: 100%;`"
                      color="cyan white--text"
                      depressed
                      class="custom-bold-button"
                    >
                      Get Schedule
                    </v-btn>
                  </td>
                </tr>
              </table>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <ConfirmSchedule
        :dialog="scheduleConfirmDialog"
        :key="`job-confirm-schedule-${uniqueCId}`"
        v-on:close="scheduleConfirmDialog = false"
      />
    </v-col>
    <v-col v-if="vPShowCalendar" md="8">
      <Calendar
        :key="`job-recurring-calendar-${scheduleKey}`"
        :show-calendar="vPShowCalendar"
      ></Calendar>
    </v-col>
    <ShowSchedule
      v-if="scheduleDialog"
      :dialog="scheduleDialog"
      :key="`job-show-schedule-${uniqueId}`"
      v-on:close="scheduleDialog = false"
      v-on:next="nextStepSchedule()"
    />
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
/* import ScheduleTeam from "@/view/components/ScheduleTeam.vue"; */
import ShowSchedule from "@/view/components/ShowSchedule.vue";
import ConfirmSchedule from "@/view/components/ConfirmSchedule.vue";
import DatePicker from "@/view/components/QDatePicker.vue";
import TimePicker from "@/view/components/TimePicker.vue";
import Calendar from "@/view/pages/partials/Calendar.vue";
import {
  UPDATE_DEFAULT_DATE,
  GET_RECURRING_DATE,
  UPDATE_CALENDAR_ACTION,
  UPDATE_SCHEDULE_STATE,
  /* RESET_ENGINEER, */
} from "@/core/services/store/preventive.module";
import moment from "moment-timezone";

moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);

export default {
  name: "job-ctx-recurring-schedule",
  data() {
    return {
      scheduleConfirmDialog: false,
      scheduleDialog: false,
      preventiveId: 0,
      loadingDialog: false,
      uniqueId: Number(new Date()),
      uniqueCId: Number(new Date()),
      todayDate: moment(new Date()).format("YYYY-MM-DD"),
      scheduleKey: Number(new Date()),
      timeOut: null,
      dialogTimeOut: null,
    };
  },
  methods: {
    updateSelection(dayId) {
      const isSelected = this.prventiveRecurringSchedule.weeks.includes(dayId);
      if (isSelected) {
        this.prventiveRecurringSchedule.weeks =
          this.prventiveRecurringSchedule.weeks.filter(
            (selectedDay) => selectedDay !== dayId
          );
      } else {
        if (
          this.prventiveRecurringSchedule.weeks.length <
          this.allowedSelections()
        ) {
          this.prventiveRecurringSchedule.weeks.push(dayId);
        }
      }

      this.$nextTick(() => {
        this.updateSchedule();
      });
    },
    allowedSelections() {
      const selectedFrequencyData = this.recurringPScheduleTypeList.find(
        (item) => item.value === this.prventiveRecurringSchedule?.type?.value
      );
      return selectedFrequencyData ? selectedFrequencyData?.max_allowed : 0;
    },
    isDisabled(dayId) {
      return (
        this.allowedSelections() ===
          this.prventiveRecurringSchedule.weeks.length &&
        !this.prventiveRecurringSchedule.weeks.includes(dayId)
      );
    },
    nextStepSchedule() {
      this.scheduleDialog = false;
      this.$nextTick(() => {
        this.uniqueCId = Number(new Date());
        this.scheduleConfirmDialog = true;
      });
    },
    showSchedule() {
      this.$store.dispatch(GET_RECURRING_DATE);
      this.uniqueId = Number(new Date());
    },
    openDialog() {
      if (this.preventiveScheduleOutput.length) {
        this.loadingDialog = true;
        this.$store.commit(UPDATE_SCHEDULE_STATE, {
          key: "preventiveScheduleOutput",
          value: this.prventiveRawScheduleOutput,
        });
        clearTimeout(this.dialogTimeOut);
        this.dialogTimeOut = setTimeout(() => {
          this.scheduleDialog = true;
          this.loadingDialog = false;
          this.scheduleConfirmDialog = false;
        }, 200);
      }
    },
    formatDate(date) {
      if (moment(date).isValid()) {
        return moment(date).format("DD MMMM YYYY");
      }
    },
    updateWeekDays(param) {
      this.updateScheduleState("dbPRecurringSchedule.occurrence", 1);
      this.updateScheduleState("dbPRecurringSchedule.weeks", []);
      this.updateScheduleState("dbPRecurringSchedule.type", param);
      this.updateEndDate(true);
      this.updateScheduleState("dbPRecurringSchedule.force_update", false);
    },
    reschduleAllVisit($event) {
      if (
        this.preventiveScheduleOutput &&
        this.preventiveScheduleOutput.length &&
        this.preventiveScheduleOutput.length > 1 &&
        this.initialStartDate &&
        this.initialEndDate
      ) {
        if ($event == 0) {
          this.updateScheduleState(
            "dbPRecurringSchedule.start_date",
            this.initialStartDate
          );
          this.updateScheduleState("dbPRecurringSchedule.force_update", true);
          this.updateEndDate(true);
          this.$store.commit(UPDATE_SCHEDULE_STATE, {
            key: "dbPRecurringSchedule.schedule_flag",
            value: $event,
          });
        } else {
          this.updateScheduleState(
            "dbPRecurringSchedule.start_date",
            this.initialEndDate
          );
          this.updateEndDate(true);
          this.updateScheduleState("dbPRecurringSchedule.force_update", true);
          this.$store.commit(UPDATE_SCHEDULE_STATE, {
            key: "dbPRecurringSchedule.schedule_flag",
            value: $event,
          });
        }
      }
      /* console.log({$event})
      console.log({preventiveScheduleOutput}) */
    },
    updateEndDateOld(force) {
      let startDateTime = moment(
        `${this.prventiveRecurringSchedule.start_date} ${this.prventiveRecurringSchedule.start_time}`
      );
      let endDateTime = moment(
        `${this.prventiveRecurringSchedule.end_date} ${this.prventiveRecurringSchedule.end_time}`
      );

      if (force === true || endDateTime.isSameOrBefore(startDateTime)) {
        let endDate = null;
        switch (this.prventiveRecurringSchedule?.type?.value) {
          case "daily":
            endDate = startDateTime.add(1, "day").format("YYYY-MM-DD");
            break;
          case "weekly":
            endDate = startDateTime.add(7, "day").format("YYYY-MM-DD");
            break;
          case "twice_a_week":
            endDate = startDateTime.add(3, "day").format("YYYY-MM-DD");
            break;
          case "fort_nightly":
            endDate = startDateTime.add(14, "day").format("YYYY-MM-DD");
            break;
          case "thrice_a_week":
            endDate = startDateTime.add(2, "day").format("YYYY-MM-DD");
            break;
          case "monthly":
            endDate = startDateTime.add(1, "month").format("YYYY-MM-DD");
            break;
          case "twice_a_month":
            endDate = startDateTime.add(1, "month").format("YYYY-MM-DD");
            break;
          case "bi_monthly":
            endDate = startDateTime.add(2, "month").format("YYYY-MM-DD");
            break;
          case "quarterly":
            endDate = startDateTime.add(3, "month").format("YYYY-MM-DD");
            break;
          case "bi_annually":
            endDate = startDateTime.add(6, "month").format("YYYY-MM-DD");
            break;
          case "annually":
            endDate = startDateTime.add(1, "year").format("YYYY-MM-DD");
            break;
        }

        this.updateScheduleState("dbPRecurringSchedule.end_date", endDate);
        this.updateScheduleState("dbPRecurringSchedule.force_update", false);
      }
    },
    updateEndDate(force) {
      let startDateTime = moment(
        `${this.prventiveRecurringSchedule.start_date} ${this.prventiveRecurringSchedule.start_time}`
      );
      let endDateTime = moment(
        `${this.prventiveRecurringSchedule.end_date} ${this.prventiveRecurringSchedule.end_time}`
      );

      if (force === true || endDateTime.isSameOrBefore(startDateTime)) {
        let endDate = null;
        switch (this.prventiveRecurringSchedule?.type?.value) {
          case "daily":
            endDate = startDateTime.add(1, "day").format("YYYY-MM-DD");
            break;
          case "weekly":
            endDate = startDateTime.add(7, "day").format("YYYY-MM-DD");
            break;
          case "twice_a_week":
            endDate = startDateTime.add(3, "day").format("YYYY-MM-DD");
            break;
          case "fort_nightly":
            endDate = startDateTime.add(14, "day").format("YYYY-MM-DD");
            break;
          case "thrice_a_week":
            endDate = startDateTime.add(2, "day").format("YYYY-MM-DD");
            break;
          case "monthly":
            endDate = startDateTime.add(12, "month").format("YYYY-MM-DD");
            break;
          case "twice_a_month":
            endDate = startDateTime.add(12, "month").format("YYYY-MM-DD");
            break;
          case "bi_monthly":
            endDate = startDateTime.add(12, "month").format("YYYY-MM-DD");
            break;
          case "quarterly":
            endDate = startDateTime.add(12, "month").format("YYYY-MM-DD");
            break;
          case "bi_annually":
            endDate = startDateTime.add(12, "month").format("YYYY-MM-DD");
            break;
          case "annually":
            endDate = startDateTime.add(1, "year").format("YYYY-MM-DD");
            break;
        }
        let formatDateEndDate = moment(endDate)
          .subtract(1, "day")
          .format("YYYY-MM-DD");
        this.updateScheduleState(
          "dbPRecurringSchedule.end_date",
          formatDateEndDate
        );
        this.updateScheduleState("dbPRecurringSchedule.force_update", false);
      }
    },
    updateSchedule() {
      clearTimeout(this.timeOut);
      this.timeOut = setTimeout(() => {
        this.showSchedule();
      }, 200);
    },
    updateDefaultDate() {
      this.$nextTick(() => {
        this.$store.dispatch(UPDATE_DEFAULT_DATE, "recurring");
      });
    },
    updateScheduleState(key, value) {
      this.$store.commit(UPDATE_SCHEDULE_STATE, { key, value });
      /*  this.$store.commit(RESET_ENGINEER); */
      this.updateDefaultDate();
      this.updateSchedule();
    },
    updateCalendar() {
      this.$store.commit(UPDATE_CALENDAR_ACTION);
    },
  },
  components: {
    /* ScheduleTeam, */
    ShowSchedule,
    ConfirmSchedule,
    Calendar,
    TimePicker,
    DatePicker,
  },
  mounted() {
    this.updateSchedule();
    this.updateDefaultDate();
    this.updateScheduleState("dbPRecurringSchedule.force_update", true);
  },
  created() {
    this.preventiveId = Number(this.$route?.query?.preventive ?? 0);
  },
  computed: {
    ...mapGetters([
      "defaultStartedAt",
      "defaultFinishedAt",
      "durationList",
      "vPShowCalendar",
      "recurringPScheduleTypeList",
      "PWeekDays",
      "prventiveRecurringSchedule",
      "preventiveEditData",
      "prventiveLoading",
      "preventiveScheduleOutput",
      "prventiveRawScheduleOutput",
      "initialStartDate",
      "initialEndDate",
    ]),

    updatedDate() {
      let endTime = moment(
        this.prventiveRecurringSchedule.start_time,
        "hh:mm A"
      )
        .add(60, "minutes")
        .format("hh:mm A");
      this.updateScheduleState("dbPRecurringSchedule.end_time", endTime);
      return endTime;
    },
    todayTime() {
      if (
        Number(
          moment(this.prventiveRecurringSchedule.start_time, "hh:mm A").format(
            "mm"
          )
        ) > 0
      ) {
        let startTime = moment(
          this.prventiveRecurringSchedule.start_time,
          "hh:mm A"
        ).add(60, "minutes");
        return startTime.format("hh:00 A");
      }
      return moment(this.prventiveRecurringSchedule.start_time).format(
        "hh:mm A"
      );
    },
  },
};
</script>
